import {useAtom} from 'jotai';
import persistentAtom from 'shared/atoms/persistent-atom';
import {ProfileProps} from '../types';

const profileAtom = persistentAtom<ProfileProps | null>('profile', null);

const useProfileStorage = () => {
  const [profile, setProfile] = useAtom(profileAtom);
  return {profile, setProfile: setProfile as any};
};

export default useProfileStorage;
